import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";
import { ebaySearchString } from "../../../utils/ebaySearchString";
import openInNewTab from "../../../utils/openInNewTab";


export default function EbayLinkButton({
  query,
  href,
  title = "Search eBay",
}: {
  query?: string;
  href?: string;
  title?: string;
}) {
  const url = href ?? (query ? ebaySearchString(query) : null);

  if (!url) {
    return null;
  }

  return (
    <div
      title={title}
      className="flex min-w-14 max-w-16 px-2 gap-x-1 items-center cursor-pointer border rounded-full bg-slate-200 border-blue-400 hover:scale-105 transition-all"
      onClick={() => openInNewTab(url)}
    >
      <img src={`/ebayLogo.svg`} className="w-6 h-6" />
      <ArrowTopRightOnSquareIcon className="text-gray-600 w-3 h-3" />
    </div>
  )
}